<template>
<div>
  <v-row>
    <v-col cols="12" class="d-flex justify-end w-100">
      <div class="d-flex" v-if="(project.status==flow[0].value||project.status==flow[2].value)&&!isDelete&&userDataCookie.depNo==toCode(project.depNo)">
        <VBtn  v-if="applyNo" 
        @click="editSave" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="primary" >
          編輯儲存
        </VBtn>
        <VBtn  v-else 
        @click="save" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="primary" >
          儲存
        </VBtn>
        <VBtn  v-if="applyNo&&userDataCookie.userno==project.createEmpNo" 
        @click="deleteBtn" 
        variant="tonal" 
        class="mr-2" 
        :loading="loadingBtn"
        color="error" >
          刪除
        </VBtn>
        <VBtn  v-if="applyNo&&isAssociationContact(userDataCookie, submissionAsContact)" 
        @click="send" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="success">
          送出
        </VBtn>
      </div>
      <div class="d-flex" v-if="(project.status==flow[1].value||project.status==flow[3].value)">
        <VBtn @click="revoked" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToRevoke" 
        class="mr-2"
         variant="tonal" 
        :loading="loadingBtn"
         color="error" >
          收回
         </VBtn>
        <VBtn @click="reject" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToApprove" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="error" >
          駁回
        </VBtn>
        <VBtn @click="approve" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToApprove" 
        variant="tonal" 
        class="mr-2" 
        :loading="loadingBtn"
        color="primary" >
          提交會議審議
        </VBtn>
      </div>
      <div class="d-flex" v-if="(project.status==flow[7].value||project.status==flow[9].value)">
        <VBtn @click="revise" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToApprove" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="warning" >
          回覆修正
        </VBtn>
        <VBtn @click="reject" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToReject" 
        class="mr-2" 
        variant="tonal" 
        :loading="loadingBtn"
        color="error" >
          駁回
        </VBtn>
        <VBtn @click="archive" 
        v-if="actionBtn&&actionBtn.actions&&actionBtn.actions.ableToApprove" 
        variant="tonal" 
        class="mr-2" 
        :loading="loadingBtn"
        color="primary" >
          備查
        </VBtn>
      </div>
      <div class="d-flex" v-if="project.status==flow[5].value&&isUcanAnnounce">
        <VBtn @click="announce" 
        class="mr-2" 
        variant="tonal" 
        color="success" >
          公告
        </VBtn>
      </div>
    </v-col>
  </v-row>
  <v-form ref="formRef">
  <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-text>
            <v-row>
              <VCol cols="12">
                <div class="text-subtitle-2 text-high-emphasis">計畫項目<Required/></div>
                <v-select
                  :items="programList"
                  item-title="projectTitle"
                  item-value="projectId"
                  v-model="project.projectId"
                  clearable
                  return-object
                  :rules="[rules.required]"
                  required
                ></v-select>
              </VCol>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">培訓計畫<Required/></div>
                <VRow>
                  <VCol cols="12" md="12">
                    <div v-if="typeof project.trainingPlanFile=='string'&&project.trainingPlanFile" class="d-flex justify-space-between">
                      <div class="d-flex align-center">
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a class="ml-2" target="_blank" @click.prevent="getJwtBeforeRedirect(project.trainingPlanFileId)" href=""  >{{project.trainingPlanFile??project.trainingPlanFileId}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clear('trainingPlanFile')"></v-btn>
                    </div>
                    <VFileInput v-else v-model="project.trainingPlanFile" :rules="[rules.required]" accept="pdf/*"  @change="handleOfficalFile('trainingPlanFile')" @click:clear="handleClearFile('trainingPlanFile')"/>
                  </VCol>
                  <VCol cols="12" class="d-flex align-center pt-0">
                    <v-icon icon="tabler-file-download"></v-icon>
                    <span class="mr-2">培訓計畫範例</span>
                    <a href="" @click.prevent="getJwtBeforeRedirect(project.projectId.planSampleFile)" 
                    v-if="project.projectId.planSampleFile">{{project.projectId.planSampleFileName?project.projectId.planSampleFileName:'培訓計畫範例'}}</a>
                  </VCol>
                </VRow>
              </v-col>

              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">遴選辦法<Required/></div>
                <VRow>
                  <VCol cols="12">
                    <div v-if="typeof project.selectionFile=='string'&&project.selectionFile" class="d-flex justify-space-between">
                      <div class="d-flex align-center">
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a class="ml-2" target="_blank"  @click.prevent="getJwtBeforeRedirect(project.selectionFileId)" href="">{{project.selectionFile??project.selectionFileId}}</a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="handleClearFileMultiple('selectionFile')"></v-btn>
                    </div>
                    <VFileInput v-else counter show-size multiple v-model="project.selectionFile" :rules="[rules.fileLimitLength]" accept="pdf/*"  @change="handleOfficalFileMultiple('selectionFile','selectionFileId')" @click:clear="handleClearFileMultiple('selectionFile')"/>
                  </VCol>
                  <VCol cols="12" class="d-flex align-center pt-0">
                    <v-icon icon="tabler-file-download"></v-icon>
                    <span class="mr-2">遴選辦法範例</span>
                    <a @click.prevent="getJwtBeforeRedirect(project.projectId.memberSampleFile)"
                    href="" v-if="project.projectId.memberSampleFile">
                    {{project.projectId.memberSampleFileName?project.projectId.memberSampleFileName:'遴選辦法'}}</a>
                  </VCol>
                  
                </VRow>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 text-high-emphasis">附件資料</div>
                  <div v-if="typeof project.otherZipFileDoc=='string'&&project.otherZipFileDoc" class="d-flex justify-space-between">
                    <div class="d-flex align-center">
                      <v-icon icon="tabler-paperclip"></v-icon>
                      <a class="ml-2" target="_blank"  @click.prevent="getJwtBeforeRedirect(project.otherZipFile)" href=""    >{{project.otherZipFileDoc?project.otherZipFileDoc:'附件資料'}}</a>
                    </div>
                    <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clearMultipleZip('otherZipFileDoc','otherZipFile')"></v-btn>
                  </div>
                  <VFileInput v-else multiple v-model="project.otherZipFileDoc" @change="handleOfficalFileMultiple('otherZipFileDoc','otherZipFile')" @click:clear="clearMultipleZip('otherZipFileDoc','otherZipFile')"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card height="100%">
          <v-card-text>
            <v-row>
              <UserInfo
                :isShow="[true,true,true,true,true,true]"
                :application-number="applyNo"
                :status="project.status"
                :issue-date="project.issueDate?toTaiwanDateDetail(project.issueDate,'-','-'):''"
                :document-number="project.documentNumber"
                :user-info="project.applyUser"
                status-component="TrainingPlanApplication"
                />
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
  </v-row>
  </v-form>
  <v-form ref="formArchive">
  <div >
    <VCard 
    v-if="(project.status == flow[5].value||project.status == flow[6].value||project.status == flow[7].value||project.status == flow[8].value||project.status == flow[9].value)"
    class="mt-4" >
      <VCardText>
          <v-row>
            <v-col cols="12" sm="4">
              <v-list-subheader>審查日期<Required/></v-list-subheader>
              <AppDateTimePicker required v-model="project.reviewDate" placeholder="選擇日期"
                       :rules="[rules.required]"/>
            </v-col>
            <v-col cols="12" sm="4">
              <v-list-subheader>會議決議<Required/></v-list-subheader>
              <div v-if="typeof project.reviewRecord=='string'&&project.reviewRecord" class="d-flex justify-space-between">
                <div>
                  <v-icon icon="tabler-paperclip"></v-icon>
                  <v-btn
                    variants="plain"
                    class="ml-2 bg-white"
                  >
                  <a target="_blank"  @click.prevent="getJwtBeforeRedirect(project.reviewRecordId)" href=""    >{{project.reviewRecord}}</a>
                  </v-btn>
                </div>
                <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clear('reviewRecord')"></v-btn>
              </div>
              <VFileInput v-else v-model="project.reviewRecord" accept="pdf/*"  @change="handleOfficalFile('reviewRecord')" @click:clear="handleClearFile('reviewRecord')" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="12" sm="4">
              <v-list-subheader>審查公文號<Required/></v-list-subheader>
              <v-text-field v-model="project.reviewDocumentNumber"  required :rules="[rules.required]"></v-text-field>
            </v-col>
          </v-row>
      </VCardText>
    </VCard>
    <VCard class="mt-4" 
    v-if="(project.status!== flow[0].value&&project.status !==flow[2].value && project.status!==flow[8].value )">
      <VCardText>
        <v-row>
          <v-col cols="12">
            <AppTextarea rows="1" auto-grow label="審查意見" placeholder="輸入審查意見" v-model="project.reviewComments"></AppTextarea>
          </v-col>
        </v-row>
      </VCardText>
    </VCard>
  </div>
  </v-form>
  <div v-if="project.status !== flow[0].value">
    <v-expansion-panels class="mt-4">
      <VExpansionPanel>
        <VExpansionPanelTitle>
          簽核歷程
        </VExpansionPanelTitle>
        <VExpansionPanelText>

          <VDataTable :items="signOffProcess" :items-length="signOffProcess.length" :headers="headers"
            class="text-no-wrap">
            <template #item.number="{ item,index }">
              {{index+1}}
            </template>
            <template #item.processTime="{ item }">
              {{toTaiwanDateDetail(item.processTime,'-','/')}}
            </template>
            <template #item.reviewRecord="{ item }">
              <div class="d-flex align-center">
                <a :href="fileUrl+'/api/v2/files/public/' + item.reviewFile">{{item.reviewFileName}}</a>
              </div>
            </template>
            <template #item.plan="{ item }">
              <div class="d-flex align-center">
                <a :href="fileUrl+'/api/v2/files/public/' + item.trainingPlanFileId">{{item.trainingPlanFileName}}</a>
              </div>
            </template>
            <template #item.selection="{ item }">
              <div class="d-flex align-center">
                <a :href="fileUrl+'/api/v2/files/public/' + item.selectionFileId">{{item.selectionFileName}}</a>
              </div>
            </template>
          </VDataTable>
        </VExpansionPanelText>
      </VExpansionPanel>
    </v-expansion-panels>
  </div>
</div>
</template>

<script setup lang="ts">
import { computed, reactive } from 'vue';
import { useRoute } from 'vue-router';
import UserInfo from './UserInfoComponent.vue';
import Required from '../../../components/required.vue'
import { useSessionStorage } from '@vueuse/core';
import { isAssociationContact } from '@/utils/deUtil'
// 
// 收回btn > 草稿stats
// 重新送出ㄉ送出 > 重新送出 // 送出stats
// 回復修正ㄉ送出 > 重新送出 // 送出stats
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'TRAININGPLAN', //系統代碼(系統授權設定中的系統代碼)
  },
})
const loadingBtn = ref(false)
const actionBtn = reactive({})
const userDataCookie = useStorage('userData', {}).value
const editProject = reactive({})
const isUcanAnnounce= ref(false)
const isDelete=ref(false)
const formRef = ref(null)
const formArchive = ref(null)
const fileUrl = useStorage('drFsUrl').value
const submissionAsContact = useSessionStorage('SubmissionAsContact')
const route = useRoute()
const flow=reactive([
  {key:'草稿',value:'Draft'},
  {key:'送出',value:'Submitted'},
  {key:'回覆修正',value:'ReturnedForRevision'},
  {key:'重新送出',value:'Resubmitted'},
  {key:'駁回',value:'Rejected'},
  {key:'通過',value:'Passed'},
  {key:'審議',value:'Reviewing'},
  {key:'核准',value:'Approved'},
  {key:'結案',value:'Closed'},
  {key:'修正送出',value:'Revised'},
])
const applyNo=ref('')
const project = reactive({
  refreshForm:0,
  formId:'',
  applicationNumber:'',
  title:'',
  projectId:"",
  status:'Draft',
  issueDate:'',
  documentNumber:'',
  applyUser:userDataCookie.userno,
  reviewDate:'',
  reviewRecord:[],             // 審查會議記錄
  reviewRecordId:'',            // 審查會議記錄ID
  reviewDocumentNumber:'',
  trainingPlanFile:[],         // 培訓計畫File
  trainingPlanFileId:'',        // 培訓計畫File ID
  trainingPlanFileExample:{},  // 培訓計畫範例
  selectionFile:[],            // 遴選辦法File
  selectionFileId:'',          // 遴選辦法File ID
  selectionFileExample:{},     // 遴選辦法File 範例
  otherZipFileDoc:[],           // 附件資料File
  otherZipFile:"",              // 附件資料File ID
  depNo:userDataCookie.depNo,
  createEmpNo:userDataCookie.userno,

})
const headers = ref([
  { title: '#', key: 'number' },
  { title: '處理人員', key: 'cName' },
  { title: '處理時間', key: 'processTime' },
  { title: '處理動作', key: 'actionDesc' },
  { title: '簽核意見', key: 'reviewComment' },
  { title: '審議紀錄', key: 'reviewRecord' },
  { title: '培訓計畫', key: 'plan' },
  { title: '遴選辦法', key: 'selection' },
]);
const signOffProcess = reactive([])

// const items= reactive([])
// rules 因計畫項目return-object 所以多增加判斷
const rules= reactive({
  required: value => {
    if (typeof value === 'object' && value !== null) {
      if(value.projectId){
        return value.projectId !== undefined || '此欄位為必填';
      }else{
        // file feild
        return !!value || '此欄位為必填';
      }
    }
    return !!value || '此欄位為必填';
  },
  fileLimitLength: (value: any) =>{
    if(Array.isArray(value)){
      if(value.length>2){
        return '只允許最多兩個檔案'
      }else{
        return value.length>0 && value.length<3 ||'此欄位為必填'
      }
    }
  },
});
const popSwal = (icon, title, text) => {
  $swal({
    position: 'top-end',
    icon: icon,
    title: title,
    text: text,
    showConfirmButton: false,
    ...(icon === 'success' ? { timer: 1500 } : {}),
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  });
}
// API---------------------------------------------------------------
// JWT
const getJ = async()=>{
  const { data: jwt } = await useApi<any>(createUrl('/tca/file/get', {})) 
  return jwt
}
// 取得檔案API
const getFile = async (code) => {
  let apiUrl = fileUrl+'/api/v2/files/public/' + code + '/meta';
  try {
    const resp = await $api(apiUrl, {
      method: 'GET',
    });
    if (resp) {
      return resp;
    } else {
      console.error("Invalid response structure", resp);
      return null;
    }
  } catch (error) {
    console.error("API request failed", error);
    return null;
  }
}

// 取得簽核歷程API
const getWorkHistory = async(formId)=>{
  let apiUrl = '/tca/trainingplan/work-history/'+formId
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    Object.assign(signOffProcess, resp)
  })
}

// 上傳文件
const uploadFile =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/upload`, {
      method: 'POST',
      body: files,
    });
    project[val] = response.fileId
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}
// 上傳文件-多檔
const uploadFileMultiple =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/uploadFiles`, {
      method: 'POST',
      body: files,
    });
    project[val] = response.zipIdd
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}

// 取得查詢單一筆申請單號API
const getProject = async(val)=>{
  let applyNoSearch = val?val:applyNo.value
  await $api('/tca/trainingplanlist/api/training-plans-list/search', {
    method: 'GET', //依據後端 restful api 的 method 設定
    query: {applyNo:applyNoSearch} // query string
  }).then((resp) => {
    Object.assign(editProject, resp)
  })
}

// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = '/form/getFormActions/' + formId;
  await $api(apiUrl, {
    method: 'GET',
  }).then((resp) => {
    if (resp) {
      Object.assign(actionBtn, resp);
      console.log(actionBtn)
    } else {
      console.error("Invalid response structure", resp);
    }
  }).catch((error) => {
    console.error("API request failed", error);
  });
};
// 下拉 API
const { data: dropdownList, execute: fetchDropdownList } = await useApi<any>(createUrl('/tca/trainingplanlist/dropdown'))
const programList = computed(()=>dropdownList?.value?dropdownList.value.projectResponse:[])

// 儲存培訓計畫申請API
const addProject = async (body) => {
  loadingBtn.value=true
  await $api('/tca/trainingplan/api/training-plan/save', {
    method: 'POST', //依據後端 restful api 的 method 設定
    body: body, // requst body
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};

// 刪除培訓計畫API
const deleteProject =async()=>{
  loadingBtn.value=true
  const apiUrl='/tca/trainingplan/api/training-plan/delete?applyNo='+applyNo.value
  await $api(apiUrl, {
    method: 'DELETE', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      isDelete.value=true
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
}

// 送出API
const submitProject = async (applyNo) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/submit/'+ applyNo
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// 收回API
const revokeProject = async (applyNo) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/withdraw/'+ applyNo
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
  }).then((resp) => {
      if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// 承辦駁回 API rejectBtn
const rejectProject = async (body) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/reject'
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body,
  }).then((resp) => {
      if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// 承辦核准 API approveBtn
const approveProject = async (body) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/approve'
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// 回復修正 API reviseBtn
const reviseProject = async (body) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/revise'
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// archive備查 API archiveBtn
const archiveProject = async (body) => {
  loadingBtn.value=true
  let apiUrl = '/tca/trainingplan/api/training-plan/archive'
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
    body:body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
    loadingBtn.value=false
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
    loadingBtn.value=false
  })
};
// announce公告 API announceBtn
const announceProject = async (val) => {
  let param = val?val:applyNo.value
  let apiUrl = '/tca/trainingplan/api/training-plan/announce/'+param
  await $api(apiUrl, {
    method: 'POST', //依據後端 restful api 的 method 設定
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,'')
      getProject(resp.data)
    }else{
      popSwal('error',resp.message,'')
    }
  }).catch((error) =>{
    popSwal('error','請稍後再試','')
  })
};
// ------------------------------------------------API

// file download
const getJwtBeforeRedirect = async (fileId) => {
  const url = await mapFileDownload(fileUrl, fileId)
  window.open(url, '_blank');
};

//
const handleClearFile =(val)=>{
  project[val]=''
  project[val+'Id']=''
}
//
const handleClearFileMultiple =(val)=>{
  project[val]=[]
  project[val+'Id']=''
}

// 上傳文件
const handleOfficalFile = (val) => {
  if (project[val]) {
    // let arr =[]
    const formData = new FormData();
    project[val].forEach((file, index) => {
      formData.append('file', file);
    });
    uploadFile(formData,val+'Id')
  }
};
// 上傳文件-多檔
const handleOfficalFileMultiple = (valFile , valId) => {
  console.log(project[valFile])
  if (project[valFile]) {
    // let arr =[]
    const formData = new FormData();
    project[valFile].forEach((file, index) => {
      formData.append('multiFiles', file);
    });

    uploadFileMultiple(formData,valId)
  }
};
// 清除file 及fileId
const clear =(fileName)=>{
  project[fileName]=[]
  project[fileName+'Id']=''
}
// 清除file 及fileId
const clearMultiple =(fileName)=>{
  project[fileName]=[]
  project[fileName+'Id']=''
}
// 清除file 及fileId
const clearMultipleZip =(file,fileId)=>{
  project[file]=[]
  project[fileId]=''
}

const saveData = async() =>{
  let newProject = {
    applyEmpNo: project.applyUser,
    applyNo: applyNo.value,
    projectId: project.projectId.projectId,
    selectionFile: project.selectionFileId,
    status: project.status,
    trainingPlanName: project.title,
    trainingPlanFile: project.trainingPlanFileId,
    otherZipFile:project.otherZipFile,
  };
  return newProject
}

const flowData = async() =>{
  let data ={
    applyNo: applyNo.value,
    reviewComment: project.reviewComments,
    reviewDate:project.reviewDate?rocToWestern(project.reviewDate,'-','-'):'',
    reviewFile:project.reviewRecordId,
    reviewDocNo:project.reviewDocumentNumber,
  }
  return data
}

//儲存btn
const save = async () => {
  const submitConfirm = await submit();
  if(project.trainingPlanFileId&&project.selectionFileId){
    if (submitConfirm) {
      const newProject = await saveData()
      addProject(newProject)
    }
  }else{
    popSwal('error','確認檔案是成功上傳','請稍後再試')
  }
};
//另存btn
const saveAs = async () => {
  const submitConfirm = await submit();
  if(project.trainingPlanFileId&&project.selectionFileId){
    if (submitConfirm) {
      const newProject = await saveData()
      newProject.applyEmpNo=userDataCookie.userno
      newProject.applyNo=''
      newProject.status=flow[0].value
      // console.log(newProject);
      addProject(newProject)
    }
  }else{
    popSwal('error','確認檔案是成功上傳','請稍後再試')
  }
};
//編輯儲存btn
const editSave = async () => {
  const submitConfirm = await submit();
  if(project.trainingPlanFileId&&project.selectionFileId){
    if (submitConfirm) {
      const newProject = await saveData()
      console.log(newProject)
      addProject(newProject)
    }
  }else{
    popSwal('error','確認檔案是成功上傳','請稍後再試')
  }
};

// deleteBtn
const deleteBtn =()=>{
  $swal({
    title: `刪除資料`,
    text: `${applyNo.value}`,
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then((result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      deleteProject()
    }
  });
}

// 送出btn
const send =()=>{
  submitProject(applyNo.value)
}

// 收回
const revoked =()=>{
  revokeProject(applyNo.value)
}
// reject 承辦駁回
const reject =async()=>{
  $swal({
    title: `駁回資料`,
    text: `${applyNo.value}`,
    showCancelButton: true,
    confirmButtonText: "我要駁回",
    cancelButtonText: "取消",
  }).then(async (result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      const body = await flowData()
      rejectProject(body)
    }
  });
}
// approve 承辦核准
const approve =async()=>{
  const body = await flowData()
  approveProject(body)
}

// revise回復修正BTN
const revise =async()=>{
  const submitConfirm = await submitArchive();
  if(submitConfirm){
    const body = await flowData()
    reviseProject(body)
  }
}
// archive備查BTN
const archive =async()=>{
  const submitConfirm = await submitArchive();
  if(submitConfirm){
    const body = await flowData()
    console.log(body)
    archiveProject(body)
  }
}
// announce回復修正BTN
const announce =()=>{
  announceProject(applyNo.value)
}

// validate formRef
const submit = async () => {
  const { valid } = await formRef.value.validate();
  console.log(valid)
  return valid
};
const submitArchive = async () => {
  const { valid } = await formArchive.value.validate();
  console.log(valid)
  return valid
};

const updateForm = () =>{
  applyNo.value=editProject.applyNo
  project.depNo=editProject.deptNo
  project.createEmpNo=editProject.createEmpNo
  project.projectId=programList.value.filter((item)=>item.projectId==editProject.projectId)[0]
  project.title=editProject.trainingPlanName
  applyNo.value=editProject.applyNo
  project.status = editProject.status
  project.applyUser = editProject.applyEmpNo
  // 培訓計畫
  project.trainingPlanFileId=editProject.trainingPlanFile
  project.trainingPlanFile=editProject.trainingPlanFileName?editProject.trainingPlanFileName:[]
  // 遴選辦法
  project.selectionFileId=editProject.selectionFile
  project.selectionFile=editProject.selectionFileName?editProject.selectionFileName:[]
  // 附件資料
  project.otherZipFile = editProject.otherZipFile
  if (editProject.otherZipFile) {
    project.otherZipFileDoc = editProject.otherZipFileName ? editProject.otherZipFileName : '附件資料'
  } else {
    project.otherZipFileDoc = []
  }
  project.formId=editProject.formId
  project.reviewDate=editProject.reviewDate?westernToRoc(editProject.reviewDate,'-','-'):''
  project.reviewRecordId=editProject.reviewFile?editProject.reviewFile:''
  project.reviewRecord=editProject.reviewFileName?editProject.reviewFileName:[]
  project.reviewDocumentNumber=editProject.reviewDate?editProject.reviewDocNo:''
  project.reviewComments=editProject.reviewComment?editProject.reviewComment:''
}

// 更新isUcanAnnounce 公告按鈕是否呈現
watch(signOffProcess, async() => {
  let signOffProcessArchieve = signOffProcess.find((item)=>item.actionDesc==flow[7].key)
  if(signOffProcessArchieve){
    isUcanAnnounce.value = signOffProcessArchieve.userNo == userDataCookie.userno
  }
});
// 更新getProject的連動資料 file
watch(editProject, async() => {
  updateForm();

  if(editProject.status!==(flow[0].value||flow[2].value)){
    if(editProject.formId){
      getFormActions(editProject.formId)
    }
  }
  if(editProject.formId){
    getWorkHistory(applyNo.value)
  }
});

// 計畫項目選擇後更新
watch(() => project.projectId, async() => {
  console.log('watch projectId')
  if (project.projectId) {
    console.log(project.projectId)
    project.issueDate=project.projectId.publishDate?project.projectId.publishDate:project.projectId[0].publishDate
    project.documentNumber=project.projectId.docNo?project.projectId.docNo:project.projectId[0].docNo
  }else{
    project.documentNumber=""
    project.issueDate=""
    project.trainingPlanFileExample={}
    project.selectionFileExample={}
  }
});

// 使用 watch 監控查詢參數變化applyNo
watch(() => route.query.applyNo, async (newValue) => {
  if (newValue !== applyNo.value) {
    applyNo.value = newValue || '';
    getProject(applyNo.value);
    updateForm();
  }
});
// 項目計畫route projectId
watch(() => route.query.projectId, async (newValue) => {
  if (newValue !== project.projectId &&newValue) {
    project.projectId=programList.value.find((it)=>it.projectId==route.query.projectId );
  }
});

// onMounted 用來初始化數據 applyo & projectId
onMounted(() => {
  applyNo.value = route.query.applyNo || '';
  if(route.query.applyNo){
    getProject(applyNo.value)
  }
  if(route.query.projectId){
    project.projectId=programList.value.find((it)=>it.projectId==route.query.projectId );
  }
});
</script>

<style scoped>

.bg-white{
  background:none !important;
  box-shadow: none !important;
}
</style>
